export default {
  uploadedFiles: [],
  clientDownloadFiles: []
}
